import React, { useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ModalContext } from '../../../context-providers/ModalProvider';
import { clsx } from 'clsx';
import './ModalWrapper.scss';

interface ModalWrapperProps {
    headerChildren?: React.ReactNode;
    bodyChildren: React.ReactNode;
    className?: string;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({ headerChildren, bodyChildren, className }) => {
    const { closeModal } = useContext(ModalContext);

    return (
        <div className={clsx('ModalWrapper bg-dark-blue p-4 rounded-lg mx-auto', className)}>
            <div className="ModalWrapper__header flex justify-between items-center pb-4">
                {headerChildren}
                <IconButton className="ModalWrapper__close" onClick={closeModal}>
                    <CloseIcon style={{ color: 'white' }} />
                </IconButton>
            </div>
            <div className="ModalWrapper__body">
                {bodyChildren}
            </div>
        </div>
    );
};

export default ModalWrapper;
